import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { iif, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth';

export const SHOULD_SKIP_DEFAULT_HEADERS_TOKEN = new HttpContextToken(
  () => false
);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  authService = inject(AuthService);
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return of(request).pipe(
      switchMap((r) =>
        iif(
          () => this.shouldAddDefaultHeaders(r),
          this.addDefaultHeaders(r),
          of(r)
        )
      ),
      switchMap((r) => next.handle(r))
    );
  }

  private addDefaultHeaders(
    request: HttpRequest<unknown>
  ): Observable<HttpRequest<unknown>> {
    const headers = this.getDefaultHeaders();

    return of(request.clone({ setHeaders: headers }));
  }

  private shouldAddDefaultHeaders(request: HttpRequest<unknown>): boolean {
    return !request.context.get(SHOULD_SKIP_DEFAULT_HEADERS_TOKEN);
  }

  private getDefaultHeaders(): { [key: string]: string } {
    const accessToken = this.authService.getToken();
    const user = this.authService.usuario$.getValue();
    const empresa = this.authService.empresaSelecionada$.getValue();
    const headers: { [key: string]: string } = {};

    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }

    if (user) {
      headers['idUsuario'] = user.id;
    }

    if (empresa) {
      headers['guidEmpresa'] = empresa.guid;
    }

    return headers;
  }
}
